// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Terms resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient, RequestOptions } from '../http.js';

export class TermsClient {
  constructor(private readonly http: HttpClient) {}

  /** Get Terms Status via the Inferrex API. */
  async getTermsStatus(): Promise<{ accepted: boolean; currentVersion: string; acceptedVersion: string | null; acceptedAt: string | null; content: { heading: string; body: string }[] }> {
    return this.http.get<{ accepted: boolean; currentVersion: string; acceptedVersion: string | null; acceptedAt: string | null; content: { heading: string; body: string }[] }>('/v1/terms/status');
  }

  /** Accept Terms via the Inferrex API. */
  async acceptTerms(request: { version: string }, requestOptions?: RequestOptions): Promise<{ accepted: boolean; version: string; acceptedAt: string }> {
    return this.http.post<{ accepted: boolean; version: string; acceptedAt: string }>('/v1/terms/accept', request, requestOptions);
  }
}
